import React, { useRef, useEffect, useState } from "react";

// Componentes PrimeReact
import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";
import { InputText } from "primereact/inputtext";

import { getProveedorAct } from "../../../../../../API/Compras/Proveedores/ProveedoresRequest";

import AgGrid from "../../../../../../Base/Components/Tables/AgGrid/AgGrid";

const ProveedorOverlayPanel = ({ rowData, close, onChange, disabled }) => {
  const op = useRef(null);
  const buttom = useRef(null);
  const [loading, setLoading] = useState(false);
  const [proveedoresActivos, setProveedoresActivos] = useState([]);


  const obtenerProductosActivos = async () => {
    setLoading(true);
    const tempo = await getProveedorAct();
    setProveedoresActivos(tempo);
    setLoading(false);
  };

  const table = {
    Columns: [
      {
        header: "Proveedor",
        field: "CustomerName",
        flex: 1,
      },
    ],
    Data: proveedoresActivos,
    onCellClicked: e => onChange(e, rowData),
    loading: loading,
  };

  useEffect(() => {
    obtenerProductosActivos();
  }, []);

  return (
    <React.Fragment>
    <div className="p-inputgroup">
      <InputText
        value={rowData.CustomerName || ""}
        readOnly
        placeholder="Proveedor"
        onClick={!disabled ? (e) => op.current?.toggle(e) : undefined}
      />
      <Button
        ref={buttom}
        icon="pi pi-angle-down"
        style={{ padding: "0.5rem 0.3rem" }}
        type="button"
        disabled={disabled}
        onClick={!disabled ? (e) => op.current?.toggle(e) : undefined}
      />
    </div>
    <OverlayPanel
      ref={op}
      showCloseIcon
      dismissable={false}
      className="OverPanelProveedor"
      onHide={close}
    >
      <div style={{ width: 500, height: 300 }}>
        <AgGrid table={table} />
      </div>
    </OverlayPanel>
  </React.Fragment>
  );
};

export default ProveedorOverlayPanel;
